var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
var CallEndIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("path", { fillRule: "evenodd", d: "M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M15.2388889,8.20555556 L14.45,8.99444444 C15.3277778,9.7 15.8888889,10.7833333 15.8888889,12 C15.8888889,14.15 14.15,15.8888889 12,15.8888889 C9.85,15.8888889 8.11111111,14.15 8.11111111,12 C8.11111111,10.7833333 8.67222222,9.7 9.54444444,8.98888889 L8.76111111,8.20555556 C7.68333333,9.12222222 7,10.4777778 7,12 C7,14.7611111 9.23888889,17 12,17 C14.7611111,17 17,14.7611111 17,12 C17,10.4777778 16.3166667,9.12222222 15.2388889,8.20555556 Z M12.5555556,7 L11.4444444,7 L11.4444444,12.5555556 L12.5555556,12.5555556 L12.5555556,7 Z" }))); };
export default CallEndIcon;
